import { BASE_MOBILE_NAME, TENDER_REDIRECT } from '@constants';
import { isMobile } from '@utils/browser';
import { setStorage } from '@utils/localStorageService';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './index.scss';

const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUrl = `${searchParams.get('rUrl') || ''}`;

    if (!isMobile) {
      setStorage(TENDER_REDIRECT, redirectUrl);
      navigate(`/login`);
      return;
    }

    window.location.replace(
      redirectUrl
        ? `${location.origin}${BASE_MOBILE_NAME}${redirectUrl}`
        : `${location.origin}${BASE_MOBILE_NAME}/login`
    );
  }, []);

  return <></>;
};
export default RedirectPage;
